import { toValue } from "@vueuse/core";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
/** use a route query parameter as a boolean computed */
export function useRouteQueryBool(parameter, defaultValue = false) {
    const route = useRoute();
    return computed(() => {
        const p = toValue(parameter);
        return p in route.query ? route.query[p] === "true" : toValue(defaultValue);
    });
}
export function useRouteQueryNumber(parameter, defaultValue = 1) {
    const route = useRoute();
    return computed(() => {
        const p = toValue(parameter);
        if (p in route.query) {
            const v = route.query[p];
            return typeof v === "string" ? parseFloat(v) : toValue(defaultValue);
        }
        else {
            return toValue(defaultValue);
        }
    });
}
